<div class="video-component-container">
  <div
    class="attribute-editor-component video-component-settings"
    [shown]="showSettingsUI()"
  >
    <div class="attribute-editor-row">
      <div class="video-component-volume">
        <label>Volume</label>
        <div class="row">
          <div class="col-xs-12">
            <input
              min="0"
              max="100"
              type="range"
              [(ngModel)]="values.volume"
              (change)="saveVolume()"
            />
          </div>
        </div>
        <p class="range-value">{{ values.volume }}</p>
      </div>
    </div>
  </div>
  <div
    class="video-component-list file-component-list te-scrollable-container"
    rvSpinner="video-file-loader"
    [rvShowSpinner]="
      templateEditorService.loadingPresentation || stockLibraryService.loading
    "
    [ngClass]="{ 'not-empty': selectedFiles.length > 0 }"
  >
    <rv-sortable [sortableService]="sortableService">
      @for (file of selectedFiles; track file) {
        <template-editor-file-entry
          rvSortableItem
          [shown]="showSettingsUI()"
          [entry]="file"
          fileType="video"
          (removeEvent)="removeFileFromList($event)"
          [showGripHandle]="selectedFiles.length > 1"
        />
      }
    </rv-sortable>
    <template-editor-empty-file-list
      fileType="video"
      [hidden]="
        isUploading ||
        selectedFiles.length !== 0 ||
        templateEditorService.loadingPresentation
      "
    >
    </template-editor-empty-file-list>
    <basic-uploader
      uploaderId="video-list-uploader"
      [uploadManager]="uploadManager"
      validType="video"
      [shown]="isUploading"
    >
    </basic-uploader>
  </div>
  <div class="file-component-list-action-button-bar">
    <div class="pt-4 border-top">
      <button
        matButton="outlined"
        id="upload-videos-unsubscribed"
        class="tw-w-full"
        (click)="currentPlanService.showUnlockThisFeatureModal()"
        [hidden]="currentPlanService.isPlanActive()"
      >
        <strong>Upload Videos</strong>
      </button>
      <button
        matButton="outlined"
        id="video-list-uploader-label"
        class="tw-w-full"
        (click)="activateVideoUploader()"
        [disabled]="isUploading ? true : null"
        [shown]="currentPlanService.isPlanActive()"
      >
        <strong>Upload Videos</strong>
      </button>
    </div>
    <div class="mt-3">
      <button
        matButton="outlined"
        id="video-list-storage-button"
        class="tw-w-full"
        (click)="selectFromStorage()"
        [disabled]="isUploading"
      >
        <strong>Select from Storage</strong>
      </button>
    </div>
    <div class="mt-3">
      <button
        matButton="outlined"
        class="tw-w-full"
        (click)="stockLibraryService.showStockLibrary('video', boundAddFile)"
        [disabled]="
          isUploading || !featuresService.isFeatureAvailable('asset_library')
        "
      >
        <strong>Select from Stock Video Library</strong>
        @if (!featuresService.isFeatureAvailable('asset_library')) {
          <upgrade-notice feature="asset_library"></upgrade-notice>
        }
      </button>
    </div>
  </div>
</div>
